const BASE_PATH = '/ext/api'

function getApiPath (apiPath) {
  return BASE_PATH + apiPath
}

const app = {
  routerName: {
    home: 'Home',
    generalForm: 'GeneralForm',
    jobDetail: 'JobDetail',
    searchResult: 'SearchResult',
    trackResult: 'TrackResult',
    jobTrackingResult: 'JobTrackingResult',
    futureProgram: 'FutureProgram',
    motivationalFit: 'MotivationalFit',
    motivationalFitResult: 'MotivationalFitResult',
    referralPage: 'ReferralPage',
    details: 'Details',
    privacyNotice: 'PrivacyNotice',
    lifeAtBlibli: 'LifeAtBlibli',
    jobsResult:'SearchResult'
  }
}

const api = {
  base_path: BASE_PATH,
  companyProfile: getApiPath('/company/detail'),
  departments: getApiPath('/departments'),
  details: getApiPath('/employee'),
  employeeDetails: getApiPath('/employee/detail'),
  jobs: getApiPath('/job'),
  spJobs: getApiPath('/jobs'),
  locations: getApiPath('/locations'),
  employmentTypes: getApiPath('/employment-types'),
  applications: getApiPath('/applications'),
  news: getApiPath('/news'),
  motivationalFit: getApiPath('/motivational-fit'),
  schoolNames: getApiPath('/educationalDetails'),
  metadata: getApiPath('/metadata'),
  fieldValues: getApiPath('/get-field-values'),
  technicalCompetencies: getApiPath('/technical-competency'),
  getJobWithId: getApiPath('/fetch-jobs'),
  getCompanyDetails: getApiPath('/fetch-company'),
  schools: getApiPath('/schools'),
  vendorList: getApiPath('/fetch-vendors'),
  companies: getApiPath('/companies'),
  instagramPosts: getApiPath('/social-medias/instagram/get-posts')
}

const pages = {
  home: '/',
  generalForm: '/general-form',
  jobDetail: '/job-detail',
  searchResult: '/department',
  filterResult: '/department/all-departments',
  trackResult: '/track-result',
  jobTrackingResult: '/job-tracking-result',
  futureProgram: '/future-program',
  motivationalFit: '/motivational-fit-questions',
  achievements: '/achievement',
  motivationalFitResult: '/motivational-fit-result',
  referralPage: '/referral-page',
  details: '/employee',
  privacyNotice: '/privacy-notice',
  lifeAtBlibli: '/life-at-blibli',
  jobsResult: '/jobs'
}

export { app, pages, api }
